import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { default as SwiperCore, Grid, Pagination, SwiperOptions } from 'swiper';

import { CarouselCard } from '../../../../models/carousel-card.model';

SwiperCore.use([Pagination, Grid]);

@Component({
  selector: 'mom-horizontal-carousel',
  templateUrl: './horizontal-carousel.component.html',
  styleUrls: ['./horizontal-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HorizontalCarouselComponent {
  @Input() cards: CarouselCard[];
  @Output() continue = new EventEmitter<CarouselCard>();

  config: SwiperOptions = {
    initialSlide: 0,
    spaceBetween: 12,
    centeredSlides: false,
    centeredSlidesBounds: true,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.2
      },
      480: {
        slidesPerView: 2.1
      },
      928: {
        slidesPerView: 3.1,

        grid: {
          rows: 2,
          fill: 'row'
        }
      }
    }
  };
}
